import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * GlobalFooter functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalFooter {
  /**
   * Constructs a new HomeSection instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    const marquee = this.element.querySelector('.marquee')
    const self = this
    if (marquee) {
      window.addEventListener('load', (event) => {
        setTimeout(() => {
          new Waypoint({
            element: self.element,
            handler: () => {
              marquee.classList.add('start-marquee-animation')
            },
            offset: '50%'
          })
        }, 1000)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./components/global-footer/index.js